import NAME from "./constants";

export const getTemplatesRows = store => store[NAME].templates;
export const getIsLoadingTemplates = store => store[NAME].isLoadingTemplates;
